import { render } from "./StudentTimeTable.vue?vue&type=template&id=0273f6a5"
import script from "./StudentTimeTable.vue?vue&type=script&lang=js"
export * from "./StudentTimeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__